export default [
	1.875104069,
	4.69409113,
	7.854757438,
	10.99554073,
	14.13716839,
	17.27875953,
	20.42035225,
	23.5619449,
	26.70353756,
	29.84513021,
	32.98672286,
	36.12831552,
	39.26990817,
	42.41150082,
	45.55309348,
	48.69468613,
	51.83627878,
	54.97787144,
	58.11946409,
	61.26105675,
	64.4026494,
	67.54424205,
	70.68583471,
	73.82742736,
	76.96902001,
	80.11061267,
	83.25220532,
	86.39379797,
	89.53539063,
	92.67698328,
	95.81857593,
	98.96016859,
	102.1017612,
	105.2433539,
	108.3849465,
	111.5265392,
	114.6681319,
	117.8097245,
	120.9513172,
	124.0929098,
	127.2345025,
	130.3760951,
	133.5176878,
	136.6592804,
	139.8008731,
	142.9424657,
	146.0840584,
	149.225651,
	152.3672437,
	155.5088364,
	158.650429,
	161.7920217,
	164.9336143,
	168.075207,
	171.2167996,
	174.3583923,
	177.4999849,
	180.6415776,
	183.7831702,
	186.9247629,
	190.0663555,
	193.2079482,
	196.3495408,
	199.4911335,
	202.6327262,
	205.7743188,
	208.9159115,
	212.0575041,
	215.1990968,
	218.3406894,
	221.4822821,
	224.6238747,
	227.7654674,
	230.90706,
	234.0486527,
	237.1902453,
	240.331838,
	243.4734307,
	246.6150233,
	249.756616,
	252.8982086,
	256.0398013,
	259.1813939,
	262.3229866,
	265.4645792,
	268.6061719,
	271.7477645,
	274.8893572,
	278.0309498,
	281.1725425,
	284.3141351,
	287.4557278,
	290.5973205,
	293.7389131,
	296.8805058,
	300.0220984,
	303.1636911,
	306.3052837,
	309.4468764,
	312.588469,
	315.7300617,
	318.8716543,
	322.013247,
	325.1548396,
	328.2964323,
	331.438025,
	334.5796176,
	337.7212103,
	340.8628029,
	344.0043956,
	347.1459882,
	350.2875809,
	353.4291735,
	356.5707662,
	359.7123588,
	362.8539515,
	365.9955441,
	369.1371368,
	372.2787295,
	375.4203221,
	378.5619148,
	381.7035074,
	384.8451001,
	387.9866927,
	391.1282854,
	394.269878,
	397.4114707,
	400.5530633,
	403.694656,
	406.8362486,
	409.9778413,
	413.1194339,
	416.2610266,
	419.4026193,
	422.5442119,
	425.6858046,
	428.8273972,
	431.9689899,
	435.1105825,
	438.2521752,
	441.3937678,
	444.5353605,
	447.6769531,
	450.8185458,
	453.9601384,
	457.1017311,
	460.2433238,
	463.3849164,
	466.5265091,
	469.6681017,
	472.8096944,
	475.951287,
	479.0928797,
	482.2344723,
	485.376065,
	488.5176576,
	491.6592503,
	494.8008429,
	497.9424356,
	501.0840282,
	504.2256209,
	507.3672136,
	510.5088062,
	513.6503989,
	516.7919915,
	519.9335842,
	523.0751768,
	526.2167695,
	529.3583621,
	532.4999548,
	535.6415474,
	538.7831401,
	541.9247327,
	545.0663254,
	548.2079181,
	551.3495107,
	554.4911034,
	557.632696,
	560.7742887,
	563.9158813,
	567.057474,
	570.1990666,
	573.3406593,
	576.4822519,
	579.6238446,
	582.7654372,
	585.9070299,
	589.0486225,
	592.1902152,
	595.3318079,
	598.4734005,
	601.6149932,
	604.7565858,
	607.8981785,
	611.0397711,
	614.1813638,
	617.3229564,
	620.4645491,
	623.6061417,
	626.7477344,
	629.889327,
	633.0309197,
	636.1725124,
	639.314105,
	642.4556977,
	645.5972903,
	648.738883,
	651.8804756,
	655.0220683,
	658.1636609,
	661.3052536,
	664.4468462,
	667.5884389,
	670.7300315,
	673.8716242,
	677.0132168,
	680.1548095,
	683.2964022,
	686.4379948,
	689.5795875,
	692.7211801,
	695.8627728,
	699.0043654,
	702.1459581
];
